import PropTypes from 'prop-types';
import React from 'react';
import WaitingListLink from '../../../waitingList/containers/WaitingListLink';
import AppointmentsWrapper from '../../appointmentsWrapper';
import SideBySideCalendars from './sideBySideCalendars';
import StickyNames from './sideBySideStickyNames';
import BlockTimeButton from './containers/BlockTimeButton';
import WalkInListButton from './containers/WalkInListButton';
import OldWalkInListButton from './containers/OldWalkInListButton';
import { t } from '../../../../../modules/infra/i18n';

const SideBySideView = ({
  barbers,
  noBarbersWorking,
  openBlockTime,
  calendarWorkDay,
  blockedTimes,
  workday,
  noBarbersSelected,
}) => (
  <AppointmentsWrapper
    currentView="sideBySide"
    additionalButtons={[
      <BlockTimeButton onClick={openBlockTime} />,
      <WaitingListLink key="waitingListLink" />,
      <WalkInListButton key="walkInListButton" />,
      <OldWalkInListButton key="oldWalkInListButton" />,
    ]}
  >
    <div display-if={!noBarbersSelected} className="c-calendar-dayview-wrapper--side-by-side">
      <StickyNames barbersViewed={barbers} />
      <SideBySideCalendars
        barbersViewed={barbers}
        calendarWorkDay={calendarWorkDay}
        blockedTimes={blockedTimes}
        workday={workday}
      />
      <div display-if={noBarbersWorking} className="u-text-center">
        {t('appointment:side_by_side.no_barbers_working')}
      </div>
    </div>
    <div display-if={noBarbersSelected} className="u-text-center">
      {t('appointment:side_by_side.no_barbers_selected')}
    </div>
  </AppointmentsWrapper>
);
SideBySideView.propTypes = {
  barbers: PropTypes.arrayOf(PropTypes.object).isRequired,
  noBarbersWorking: PropTypes.bool.isRequired,
  noBarbersSelected: PropTypes.bool.isRequired,
  openBlockTime: PropTypes.func.isRequired,
  calendarWorkDay: PropTypes.object.isRequired,
  blockedTimes: PropTypes.object.isRequired,
  workday: PropTypes.object.isRequired,
};

export default SideBySideView;
